import { get } from 'utils/request';
const { dialog } = window.DN.Modal;

export async function fetchPCHomeText() {
  try {
    const result = (await get('https://query.aliyun.com/rest/groupBuying.home')) || {};
    return result.data;
  } catch (error) {
    console.error(error);
  }
}
export async function fetchTipsText() {
  try {
    const result = (await get('https://query.aliyun.com/rest/groupBuying.tips')) || {};
    return result.data;
  } catch (error) {
    console.error(error);
  }
}
export async function fetchMobileHomeText() {
  try {
    const result = (await get('https://query.aliyun.com/rest/groupBuying.mobileHome')) || {};
    return result.data;
  } catch (error) {
    console.error(error);
  }
}
export async function fetchPCSelfText() {
  try {
    const result = (await get('https://query.aliyun.com/rest/groupBuying.self')) || {};
    return result.data;
  } catch (error) {
    console.error(error);
  }
}
export async function fetchShareText() {
  try {
    const result = (await get('https://query.aliyun.com/rest/groupBuying.sharetext')) || {};
    return result.data;
  } catch (error) {
    console.error(error);
  }
}
export async function fetchPCShareText() {
  try {
    const result = (await get('https://query.aliyun.com/rest/groupBuying.share')) || {};
    return result.data || {};
  } catch (error) {
    console.error(error);
  }
}
export async function fetchPkText() {
  try {
    const result = (await get('https://query.aliyun.com/rest/groupBuying.pkText')) || {};
    return result.data || {};
  } catch (error) {
    console.error(error);
  }
}

export async function fetchHomeText12() {
  try {
    const result = (await get('https://query.aliyun.com/rest/groupBuying.12home')) || {};
    return result.data || {};
  } catch (error) {
    console.error(error);
  }
}

let regularContent = '';
export async function fetchyundashiRule() {
  if (regularContent) {
    dialog({
      title: '云大使协议',
      content: regularContent,
      size: 'large',
      footerPosition: 'right',
      button: [
        {
          text: '好的',
        },
      ],
    });
  } else {
    $.ajax({
      url: 'https://query.aliyun.com/rest/yundashi.qianyue',
      dataType: 'text',
      success: res => {
        regularContent = res;
        dialog({
          title: '云大使协议',
          content: regularContent,
          size: 'large',
          footerPosition: 'right',
          button: [
            {
              text: '好的',
            },
          ],
        });
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/services/TextService.js